export const EDIT_MODE = 'EDIT_MODE';
export const GET_DASHBOARDS = 'GET_DASHBOARDS';
export const GET_DASHBOARDS_TEMPLATES = 'GET_DASHBOARDS_TEMPLATES';
export const SET_DASHBOARD_FILTER = 'SET_DASHBOARD_FILTER';
export const ADD_DASHBOARD_IS_LOADING = 'ADD_DASHBOARD_IS_LOADING';
export const GET_DASHBOARD_BY_ID = 'GET_DASHBOARD_BY_ID';
